// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yufY","rootMobile":"styles_rootMobile__7Vd_8"};